import React, { useEffect, useRef } from "react";

// SASS
import "./Part9.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import handImg from "../../assets/img/pump-sanitizer.png";
import sanitizerImg from "../../assets/img/sanitizer.png";
import bubbleImg from "../../assets/img/bubbles_3.png";
import noImg from "../../assets/img/no-symbol.png";

// FUNCTION EXPORT
export default function Part9({ step }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    { stepNumber: "1", height: null, description: "fade in text2" },
    { stepNumber: "2", height: null, description: "fade in text3" },
    { stepNumber: "3", height: null, description: "fade in text4" },
    { stepNumber: "4", height: null, description: "spacer" },
  ];

  // REFS
  const text2El = useRef(null);
  const text3El = useRef(null);
  const text4El = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeInOnEnter(text2El.current, direction);
            break;
          }
          case "2": {
            animate.fadeInOnEnter(text3El.current, direction);
            break;
          }
          case "3": {
            animate.fadeInOnEnter(text4El.current, direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeOutOnExit(text2El.current, direction);
            break;
          }
          case "2": {
            animate.fadeOutOnExit(text3El.current, direction);
            break;
          }
          case "3": {
            animate.fadeOutOnExit(text4El.current, direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part9">
          <div className="sanitizer-container">
            <div className="text">
              When you disinfect, <br />
              do not rush the process.
            </div>
            <div className="sanitizer">
              <img src={sanitizerImg} alt="" className="img-fluid" />
            </div>
            <div className="hands">
              <img src={handImg} alt="" className="img-fluid" />
            </div>
            <div className="bubbles float delay-random-1">
              <img src={bubbleImg} alt="" className="img-fluid" />
            </div>
          </div>
          <div className="text-block">
            <div className="text text-1">DO NOT…</div>
            <div className="text-inner-container">
              <div className="text text-2" ref={text2El}>
                <div className="icon">
                  <img src={noImg} alt="" className="img-fluid" />
                </div>
                <div className="list-item">
                  Wipe the surface before it is dry.
                </div>
              </div>
              <div className="text text-3" ref={text3El}>
                <div className="icon">
                  <img src={noImg} alt="" className="img-fluid" />
                </div>
                <div className="list-item">
                  Blow on the surface to dry it off, because your breath has
                  germs.
                </div>
              </div>
              <div className="text text-4" ref={text4El}>
                <div className="icon">
                  <img src={noImg} alt="" className="img-fluid" />
                </div>
                <div className="list-item">
                  Blow any air on the surface, like with a fan, unless the
                  manufacturer approves it.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
